import React from 'react';
import { Avatar } from '@material-ui/core';
import cx from 'clsx';
import { QAHeader } from './QAHeader';
export var Question = function (_a) {
    var q = _a.q, info = _a.info;
    return (React.createElement(QAHeader, { title: q, titleClass: "faq-answer-title", avatar: React.createElement(Avatar, { "aria-label": "Question", className: cx('faq-answer-q') }, info ? '!' : 'Q') }));
};
//# sourceMappingURL=Question.js.map